export { Split } from './Split';
export type { Props } from './Split.types';
